import type { EmotionScore, FeedbackIconComponent, FeedbackIconProps } from '../FeedbackIconTypes';
import LoveEmoji from './images/emojis/love.png';
import LikeEmoji from './images/emojis/like.png';
import NeutralEmoji from './images/emojis/neutral.png';
import DislikeEmoji from './images/emojis/dislike.png';
import HateEmoji from './images/emojis/hate.png';
import { ImageIcon } from './ImageIcon';

export const HateEmojiIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={HateEmoji} />;
};

export const DislikeEmojiIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={DislikeEmoji} />;
};

export const NeutralEmojiIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={NeutralEmoji} />;
};

export const LikeEmojiIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={LikeEmoji} />;
};

export const LoveEmojiIcon = (props: FeedbackIconProps): JSX.Element => {
  return <ImageIcon {...props} sourceImage={LoveEmoji} />;
};

export const EmojiScoreMap: Record<EmotionScore, FeedbackIconComponent> = {
  0: HateEmojiIcon,
  1: DislikeEmojiIcon,
  2: NeutralEmojiIcon,
  3: LikeEmojiIcon,
  4: LoveEmojiIcon,
};
